import { NotificationType } from '../../../../../services/exports/Constants';

export default {
  title: 'You have {{length}} alerts',
  notifications: {
    titles: {
      [NotificationType.PaymentGatewayVerificationPending]: 'Payment info in review',
      [NotificationType.PaymentGatewayVerificationSuccessful]: 'Payment info success',
      [NotificationType.PaymentGatewayVerificationFailed]: 'Payment info error',
    },
    descriptions: {
      [NotificationType.PaymentGatewayVerificationPending]:
        'Your payment information is being reviewed by Stripe. This might take up to 48 hours.',
      [NotificationType.PaymentGatewayVerificationSuccessful]:
        'Your payment information is successfully verified. You can now receive payments.',
      [NotificationType.PaymentGatewayVerificationFailed]:
        'Seems like there was an error with your information. Please click here to update your information.',
    },
  },
};
